import { createTheme } from '@mantine/core';
import { fontFamilies } from '@ui-lib/css';

export const typography = createTheme({
  fontFamily: fontFamilies.brand,
  headings: {
    fontWeight: '600',
    sizes: {
      h1: {
        fontSize: '40px',
        lineHeight: '52px',
      },
      h2: {
        fontSize: '36px',
        lineHeight: '44px',
      },
      h3: {
        fontSize: '32px',
        lineHeight: '40px',
      },
      h4: {
        fontSize: '28px',
        lineHeight: '36px',
      },
      h5: {
        fontSize: '24px',
        lineHeight: '32px',
      },
      h6: {
        fontSize: '20px',
        lineHeight: '28px',
      },
    },
  },
});
